import { convertLocalDateTimeString } from 'components/Common/Utils/DateUtils';
import { displayShippers, formatEventTypes, formatStringList } from './fetchSharingAgreementsReport';

const formatDate = (value) =>
    value ? convertLocalDateTimeString(String(value).replace('Z', '')) : '';

export const CSV_COLUMNS = [
    { label: 'Version', getValue: (item) => item.version || '' },
    { label: 'Carrier', getValue: (item) => item.carrierName || item.carrierAccountId || '' },
    { label: 'Status', getValue: (item) => item.status || '' },
    { label: 'Group', getValue: (item) => item.groupName || '' },
    { label: 'Event types', getValue: (item) => formatEventTypes(item.eventTypes) },
    { label: 'Shippers', getValue: (item) => formatStringList(displayShippers(item.shippers)) },
    { label: 'References', getValue: (item) => formatStringList(item.references) },
    { label: 'Created', getValue: (item) => formatDate(item.createdAt) },
    { label: 'Last modified', getValue: (item) => formatDate(item.lastModifiedAt) },
    { label: 'Valid from', getValue: (item) => formatDate(item.validFrom) },
    { label: 'Valid to', getValue: (item) => formatDate(item.validTo) },
    { label: 'Direction', getValue: (item) => item.direction || '' }
];

const FORMULA_INJECTION_PREFIX = /^[=+\-@\t\r]/;

export const csvEscape = (value) => {
    let text = value == null ? '' : String(value);
    if (FORMULA_INJECTION_PREFIX.test(text)) {
        text = `'${text}`;
    }
    if (/[",\n\r]/.test(text)) {
        return `"${text.replace(/"/g, '""')}"`;
    }
    return text;
};

export const buildSharingAgreementsReportCsv = (items) => {
    const header = CSV_COLUMNS.map((column) => csvEscape(column.label)).join(',');
    const rows = (items || []).map((item) =>
        CSV_COLUMNS.map((column) => csvEscape(column.getValue(item))).join(',')
    );
    return [header, ...rows].join('\r\n');
};

export const sharingAgreementsReportCsvFilename = (status) => {
    const slug = (status || 'all').toLowerCase();
    return `sharing-agreements-report-${slug}.csv`;
};

export const downloadSharingAgreementsReportCsv = (items, status) => {
    const csv = `\uFEFF${buildSharingAgreementsReportCsv(items)}`;
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = sharingAgreementsReportCsvFilename(status);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
